import React from 'react';
import { IEntity } from '../../types';
import { RagIndicatorForRisk } from './RagIndicatorForRisk';

// Heatmap color matrix (Impact = rows, Probability = columns)
// Impact 1 is bottom row, Impact 5 is top row
export const heatmapColors: string[][] = [
    // Impact = 1
    ['#006837', '#2DA254', '#87CB66', '#CDE983', '#FEFEBE'],
    // Impact = 2
    ['#2DA254', '#87CB66', '#CDE983', '#FEFEBE', '#FCD27E'],
    // Impact = 3
    ['#87CB66', '#CDE983', '#FEFEBE', '#FCD27E', '#F88B52'],
    // Impact = 4
    ['#CDE983', '#FEFEBE', '#FCD27E', '#F88B52', '#DD3D2D'],
    // Impact = 5
    ['#FEFEBE', '#FCD27E', '#F88B52', '#DD3D2D', '#A50126']
];

export interface IRiskRagIndicatorProps {
    impactLevel: IEntity;
    probability: IEntity;
}

export const RiskRagIndicator = ({ impactLevel, probability }: IRiskRagIndicatorProps): React.ReactElement => {
    const color =
        impactLevel && probability
            ? heatmapColors[impactLevel.ID - 1][probability.ID - 1]
            : undefined;

    const label =
        impactLevel && probability
            ? `${impactLevel?.Title}/${probability?.Title}`
            : `To be completed`;

    return <RagIndicatorForRisk color={color} label={label} />;
};
